import { HttpClientModule, provideHttpClient, withInterceptors } from '@angular/common/http';
import { NgModule, provideZoneChangeDetection } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { MSAL_INSTANCE, MsalModule, MsalRedirectComponent } from '@azure/msal-angular';
import {
  BrowserCacheLocation,
  InteractionType,
  PublicClientApplication
} from '@azure/msal-browser';
import { LIBRARY_CONFIG, MSALInstanceFactory, OfflineHeaderModule } from '@gea/digital-ui-lib';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import {
  provideTranslateHttpLoader,
  TranslateHttpLoader
} from '@ngx-translate/http-loader';
import { NgxsModule } from '@ngxs/store';
import { MarkdownModule } from 'ngx-markdown';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { GeaLibraryModule } from './pages/core/shared/gea-library.module';
import { PrimeNGModule } from './pages/core/shared/prime-ng.module';
import { SharedModule } from './pages/core/shared/shared.module';
import { environment } from '../environments/environment';
import { apiInterceptor } from './pages/core/shared/interceptors/api.interceptor';
import { MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';

const runtimeConfig = (window as Window & { __appConfig?: { primeNgLicense?: string } }).__appConfig;

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    OfflineHeaderModule,
    HttpClientModule,
    AppRoutingModule,
    MsalModule.forRoot(
      new PublicClientApplication({
        auth: {
          clientId: environment.msalConfig.auth.clientId,
          authority: environment.msalConfig.auth.authority,
          redirectUri: environment.msalConfig.auth.redirectUri,
          postLogoutRedirectUri: environment.msalConfig.auth.postLogoutRedirectUri
        },
        cache: {
          cacheLocation: BrowserCacheLocation.LocalStorage,
          storeAuthStateInCookie: false
        }
      }),
      {
        interactionType: InteractionType.Redirect,
        authRequest: {
          scopes: environment.apiScopes
        }
      },
      {
        interactionType: InteractionType.Redirect,
        protectedResourceMap: new Map<string, string[]>()
      }
    ),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: TranslateHttpLoader
      }
    }),
    MarkdownModule.forRoot(),
    NgxsModule.forRoot([], {
      compatibility: {
        strictContentSecurityPolicy: true
      }
    }),
    SharedModule,
    GeaLibraryModule,
    PrimeNGModule
  ],
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    providePrimeNG({
      license: runtimeConfig?.primeNgLicense ?? ''
    }),
    provideHttpClient(withInterceptors([apiInterceptor])),
    {
      provide: LIBRARY_CONFIG,
      useFactory: () => {
        return {

          baseUrl: "http://localhost:4200/",
          legalDocumentsStorageURL: "http://localhost:4200/",
          iconStorageURL: "assets/icons/"
        };
      },
    },
    { provide: 'portalLink', useValue: environment.msalConfig!.auth.redirectUri },
    { provide: 'redirectLink', useValue: environment.msalConfig!.auth.redirectUri },
    MessageService,
    ...provideTranslateHttpLoader({ prefix: './assets/i18n/', suffix: '.json' }),
  ],
  bootstrap: [AppComponent, MsalRedirectComponent]
})
export class AppModule { }
